import Route from "react-router-dom/es/Route";
import Switch from "react-router-dom/es/Switch";
import { Constants } from "../../../constants";
import RedirectIfNotLogged from "../../menu/redirect-if-not-logged";
import FlowPage from "./flow/flow-page";
import ProductsPage from "./products/products-page";
import UsersPage from "./users/users-page";
import DepartmentsPage from "./departments/departments-page";
import UserRolePage from "./userroles/user-role-page";
import UserPositions from "./userposition/user-positions";
import AcquisitionCategories from "./categories/acquisition-categories";
import FinanceSourcePage from "./financesource/finance-source-page";
import AuthorityPage from "./authority/authority-page";

const React = require("react");

export default class AdministratorPage extends React.Component {
  render() {
    return (
      <div>
        <RedirectIfNotLogged />
        <Switch>
          <Route
            exact
            path="/app/admin/authority"
            render={props => (
              <AuthorityPage
                {...props}
                onDialogVisible={this.props.onDialogVisible}
              />
            )}
          />

          <Route
            exact
            path="/app/admin/flow"
            render={props => (
              <FlowPage
                {...props}
                onDialogVisible={this.props.onDialogVisible}
              />
            )}
          />

          <Route
            exact
            path="/app/admin/product"
            render={props => (
              <ProductsPage
                {...props}
                onDialogVisible={this.props.onDialogVisible}
              />
            )}
          />

          <Route
            exact
            path="/app/admin/user"
            render={props => (
              <UsersPage
                {...props}
                onDialogVisible={this.props.onDialogVisible}
              />
            )}
          />
          <Route
            exact
            path="/app/admin/department"
            render={props => (
              <DepartmentsPage
                {...props}
                url={Constants.SERVER_ENDPOINT + "/department"}
                title={"Compartimente"}
                addTitle={"Adauga compartiment nou"}
                editTitle={"Editeaza compartiment"}
                onDialogVisible={this.props.onDialogVisible}
                listType={Constants.LIST_TYPE_DEPARTMENT}
              />
            )}
          />
          <Route
            exact
            path="/app/admin/user-role"
            render={props => (
              <UserRolePage
                {...props}
                url={Constants.SERVER_ENDPOINT + "/user-role"}
                title={"Roluri utilizatori"}
                addTitle={"Adauga rol nou"}
                editTitle={"Editeaza rol"}
                onDialogVisible={this.props.onDialogVisible}
                listType={Constants.LIST_TYPE_USER_ROLE}
              />
            )}
          />
          <Route
            exact
            path="/app/admin/user-position"
            render={props => (
              <UserPositions
                {...props}
                url={Constants.SERVER_ENDPOINT + "/user-position"}
                title={"Functii"}
                addTitle={"Adauga functie noua"}
                editTitle={"Editeaza functie"}
                onDialogVisible={this.props.onDialogVisible}
                listType={Constants.LIST_TYPE_USER_POSITION}
              />
            )}
          />

          <Route
            exact
            path="/app/admin/acquisition-category"
            render={props => (
              <AcquisitionCategories
                {...props}
                url={Constants.SERVER_ENDPOINT + "/acquisition-category"}
                title={"Categorii achizitie"}
                addTitle={"Adauga categorie achizitie noua"}
                editTitle={"Editeaza categorie achizitie"}
                onDialogVisible={this.props.onDialogVisible}
                listType={Constants.LIST_TYPE_ACQUISITION_CATEGORY}
              />
            )}
          />

          <Route
            exact
            path="/app/admin/finance-source"
            render={props => (
              <FinanceSourcePage
                {...props}
                url={Constants.SERVER_ENDPOINT + "/finance-source"}
                title={"Surse de finantare"}
                addTitle={"Adauga sursa de finantare"}
                editTitle={"Editeaza sursa de finantare"}
                listType={Constants.LIST_TYPE_FINANCE_SOURCE}
                onDialogVisible={this.props.onDialogVisible}
              />
            )}
          />
        </Switch>
      </div>
    );
  }
}
